const HostSessionFooter = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="absolute bottom-0 border border-gray-300 bg-white font-normal font-extrabold text-2xl leading-28 shadow-2xl px-64 w-full h-[100px] flex items-center">
      {children}
    </div>
  );
};

export default HostSessionFooter;
